import { render, staticRenderFns } from "./DashboardBottomWidgets.vue?vue&type=template&id=6047905b&scoped=true"
import script from "./DashboardBottomWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardBottomWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardBottomWidgets.vue?vue&type=style&index=0&id=6047905b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047905b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6047905b')) {
      api.createRecord('6047905b', component.options)
    } else {
      api.reload('6047905b', component.options)
    }
    module.hot.accept("./DashboardBottomWidgets.vue?vue&type=template&id=6047905b&scoped=true", function () {
      api.rerender('6047905b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DashboardBottomWidgets.vue"
export default component.exports